var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 49,
    viewBox: "0 0 63 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0025 47.391L61.9923 21.7526C62.6597 20.7454 62.3892 19.3845 61.388 18.7131C61.0301 18.473 60.6096 18.3449 60.1795 18.3449H46.8208V2.20447C46.8208 0.993954 45.8454 0.0126343 44.6422 0.0126343C43.9137 0.0126343 43.2334 0.378893 42.8294 0.98866L25.8396 26.6271C25.1721 27.6343 25.4427 28.9952 26.4438 29.6666C26.8017 29.9067 27.2222 30.0348 27.6523 30.0348H41.011V46.1752C41.011 47.3857 41.9864 48.3671 43.1897 48.3671C43.9181 48.3671 44.5984 48.0008 45.0025 47.391Z",
    fill: "#001C30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.509 3.73267H25.0336C27.4402 3.73267 29.391 5.69531 29.391 8.11635C29.391 10.5374 27.4402 12.5 25.0336 12.5H10.509C8.10247 12.5 6.1516 10.5374 6.1516 8.11635C6.1516 5.69531 8.10247 3.73267 10.509 3.73267ZM10.509 38.8021H25.0336C27.4402 38.8021 29.391 40.7648 29.391 43.1858C29.391 45.6068 27.4402 47.5695 25.0336 47.5695H10.509C8.10247 47.5695 6.1516 45.6068 6.1516 43.1858C6.1516 40.7648 8.10247 38.8021 10.509 38.8021ZM4.69913 21.2674H16.3189C18.7254 21.2674 20.6762 23.23 20.6762 25.6511C20.6762 28.0721 18.7254 30.0347 16.3189 30.0347H4.69913C2.29261 30.0347 0.341736 28.0721 0.341736 25.6511C0.341736 23.23 2.29261 21.2674 4.69913 21.2674Z",
    fill: "#001C30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFast);
export default __webpack_public_path__ + "static/media/icon-fast.dc23067738b4717e761fd5c6c079cb5d.svg";
export { ForwardRef as ReactComponent };